import { render, staticRenderFns } from "./GeneralPrescription.vue?vue&type=template&id=c2003944&scoped=true"
import script from "./GeneralPrescription.vue?vue&type=script&lang=js"
export * from "./GeneralPrescription.vue?vue&type=script&lang=js"
import style0 from "./GeneralPrescription.vue?vue&type=style&index=0&id=c2003944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2003944",
  null
  
)

export default component.exports